/* biome-ignore-all lint/correctness/useUniqueElementIds: react-intl message ids are not DOM ids in this component. */
import { Modal, Tabs } from "antd";
import { FormattedMessage } from "react-intl";
import UploadImageForm from "./components/UploadImageForm";

import "./UploadPersonImageModal.css";

type Props = {
  handleClose: () => void;
  person?: any;
  updatePerson: (data: any) => void;
};

const UploadPersonImageModal = ({ handleClose, person, updatePerson }: Props) => {
  const tabItems = [
    {
      key: "head",
      label: <FormattedMessage id="imageType.head" />,
      children: (
        <UploadImageForm
          key={person?.headImageUrl || "headImageUrl"}
          imageUrl={person?.headImageUrl ?? person?.dcHeadImageUrl}
          personImagePropertyKey="headImageUrl"
          updatePerson={updatePerson}
        />
      ),
    },
    {
      key: "waist",
      label: <FormattedMessage id="imageType.waist" />,
      children: (
        <UploadImageForm
          key={person?.waistImageUrl || "waistImageUrl"}
          imageUrl={person?.waistImageUrl ?? person?.dcWaistImageUrl}
          personImagePropertyKey="waistImageUrl"
          updatePerson={updatePerson}
        />
      ),
    },
    {
      key: "pose",
      label: <FormattedMessage id="imageType.pose" />,
      children: (
        <UploadImageForm
          key={person?.poseImageUrl || "poseImageUrl"}
          imageUrl={person?.poseImageUrl ?? person?.dcPoseImageUrl}
          personImagePropertyKey="poseImageUrl"
          updatePerson={updatePerson}
        />
      ),
    },
  ];

  return (
    <Modal
      className="person-image-upload-modal"
      title={person?.nameFullLocal}
      open={!!person}
      width={350}
      footer={null}
      onCancel={handleClose}
      destroyOnHidden
    >
      <span className="person-image-upload-modal-subtitle">
        <FormattedMessage id="uploadPersonImageModal.description" />
      </span>
      <Tabs rootClassName="person-image-upload-tabs" defaultActiveKey="head" centered items={tabItems} />
    </Modal>
  );
};

export default UploadPersonImageModal;
